import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'

export const fetchPDDWarehouseToHo = createAsyncThunk(
    'fetchPDDWarehouseToHo',
    async ({ jwtBearer, movement }) => {
        const response = await fetch(`${BASE_URL}pdd/get/warehouse/recalled/data/`, {
            headers: {
                Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
            }
        })
        return response.json()
    }
)

const pddWarehouseToHoDataSlice = createSlice({
    name: 'pddWarehouseToHoDataSlice',
    initialState: {
        isLoading: false,
        data: null,
        isError: false
    },
    extraReducers: builder => {
        builder.addCase(fetchPDDWarehouseToHo.pending, (state, action) => {
            state.isLoading = true
        })
        builder.addCase(fetchPDDWarehouseToHo.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        })
        builder.addCase(fetchPDDWarehouseToHo.rejected, (state, action) => {
            console.log('Error', action.payload)
            state.isError = true
        })
    }
})

export default pddWarehouseToHoDataSlice.reducer
